import React, { useEffect, useState } from "react";
import { Typography, Box, Grid2, Link, styled, Tab, Tabs, useMediaQuery, useTheme, IconButton, Card } from "@mui/material";
import styles from "../../../styles/ProjectList.module.css";
import Divider from "@mui/material/Divider";
import NotesIcon from '@mui/icons-material/Notes';
import RiskKPI from "./RiskKPI";
import RiskTrendGraph from "./RiskTrendGraph";
import ActiveRiskGraph from "./ActiveRiskGraph";
import RiskDistributionGraph from "./RiskDistributionGraph";
import RiskHeatMatrix from "./RiskHeatMatrix";
import archiveImg from "assets/icons/archive.svg";
import activeArchiveImg from "assets/icons/activeArchive.svg";
import alignCenter from "assets/icons/aligncenter.svg";
import check from "assets/check.png";
import square from "assets/square.png";
import SubTabs from "components/SubTabs";
import subTabsItems from "components/subTabs-items";
import SafetyKPI from "./Safety/SafetyKPI";
import SafetyNCRGraph from "./Safety/SafetyNCRGraph";
import ManHoursGraph from "./Safety/ManHoursGraph";
import MissIncidenteGraph from "./Safety/MissIncidentsGraph";
import LostTimeIncidentsGraph from "./Safety/LostTimeIncidentsGraph";
import FatalitiesGraph from "./Safety/FatalitiesGraph";
import SafetyNCRList from "./Safety/SafetyNCRList";
import QualityNCRList from "./Quality/QualityNCRList";
import TopCriticalRisk from "./TopCriticalRisk";
import NCRKPI from "./Quality/NCRKpi";
import ClosedNCRGraph from "./Quality/ClosedNCRGraph";
import NCROpenStatusGraph from "./Quality/NCROpenStatusGraph";
import KeyClearancesKPI from "./KeyClearanceDashboard/KeyClearancesKPI";
import DelayAnalysisGraph from "./KeyClearanceDashboard/DelayAnalysisGraph";
import PendingClearancesGraph from "./KeyClearanceDashboard/PendingClearancesGraph";
import KeyClearancesDueMonth from "./KeyClearanceDashboard/KeyClearancesDueMonth";
import KeyClearancesList from "./KeyClearanceDashboard/KeyClearancesList";
import IssuesKPI from "./IssuesKPI";
import OpenIssuesTimeCostImpact from "./OpenIssuesTimeCostImpact";
import IssuesList from "./IssuesList";
import AgingAnalysisGraph from "./AgingAnalysisGraph";
import OpenIssueDistributionGraph from "./OpenIssueDistributionGraph";
import IssuesDistributionModuleGraph from "./IssuesDistributionModuleGraph";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";



function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

const RiskDashBoard = () => {

  const { hasPermission } = useCheckMenuPermission();
  const [value, setValue] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  useEffect(() => {
    const storedIndex = localStorage.getItem("riskTabIndex");
    if (storedIndex !== null) {
      setValue(Number(storedIndex));
    } else {
      const firstPermittedTab = subTabsItems?.riskSubTabs?.find(item =>
        hasPermission([item?.permissionKey])
      );
      if (firstPermittedTab != undefined) {
        localStorage.setItem("riskTabIndex", firstPermittedTab.index ?? 0);
        setValue(firstPermittedTab?.index ?? 0)
      }
    }
  }, [hasPermission, subTabsItems]);

  const handleChange = (newIndex) => {
    setValue(newIndex);
    localStorage.setItem("riskTabIndex", newIndex);
  };

  return (
    <>

      <SubTabs subTabs={subTabsItems?.riskSubTabs} selectedTab={handleChange} selectedIndex={value} 
      variant={isMobile ? "scrollable" : "fullWidth"} 
      scrollButtons={isMobile ? "auto" : false}
      centered={!isMobile} 
 />

      <CustomTabPanel value={value} index={0} >
        <IssuesKPI />
        <Grid2 container spacing={2} sx={{ mt: "16px" }}>
          <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
            <IssuesDistributionModuleGraph />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
            <OpenIssueDistributionGraph />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
            <AgingAnalysisGraph />
          </Grid2>
        </Grid2>
        <Grid2 container>
          <Grid2 size={{ xs: 12, md: 12, lg: 12 }} >
            <IssuesList />
          </Grid2>
        </Grid2>

      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>

        <Grid2 size={{ xs: 12, md: 12 }}>
          <Grid2 container spacing={2}>

            <Grid2 size={{ xs: 12, md: 12 }}>
              <KeyClearancesKPI />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 4 }}>
              <DelayAnalysisGraph />
              <PendingClearancesGraph />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 8 }}>
              <KeyClearancesDueMonth />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 12 }}>
              <KeyClearancesList />
            </Grid2>

          </Grid2>
        </Grid2>

      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
          <RiskKPI />
        </Grid2>
        <Grid2 container spacing={2} sx={{ mt: "10px" }}>
          <Grid2 size={{ xs: 12, md: 4, lg: 4 }}>
            <ActiveRiskGraph />
            <RiskDistributionGraph />
          </Grid2>
          <Grid2 size={{ xs: 12, md: 8, lg: 8 }}>
            <RiskTrendGraph />
          </Grid2>
        </Grid2>

        <Grid2 container spacing={2} sx={{ mt: "12px" }}>
          <Grid2 size={{ xs: 12, md: 5, lg: 5 }}>
            <RiskHeatMatrix />

          </Grid2>
          <Grid2 size={{ xs: 12, md: 7, lg: 7 }}>
            <TopCriticalRisk />
          </Grid2>
        </Grid2>
      </CustomTabPanel>

      <CustomTabPanel value={value} index={3}>

        <Grid2 size={{ xs: 12, md: 12 }}>
          <Grid2 container spacing={2}>

            <Grid2 size={{ xs: 12, md: 12 }}>
              <SafetyKPI />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <ManHoursGraph />
              <LostTimeIncidentsGraph />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 6 }}>
              {/* <SafetyNCRGraph /> */}
              <MissIncidenteGraph />
              <FatalitiesGraph />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 12 }}>
              <SafetyNCRList />
            </Grid2>

          </Grid2>
        </Grid2>

      </CustomTabPanel>

      <CustomTabPanel value={value} index={4}>
        <NCRKPI />
        <Grid2 container spacing={2} sx={{ mt: 2 }}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Card sx={{ border: '1px solid #e0e0e0', boxShadow: 'none', borderRadius: 2, height: '100%' }}>
              <ClosedNCRGraph />
            </Card>
          </Grid2>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Card sx={{ border: '1px solid #e0e0e0', boxShadow: 'none', borderRadius: 2, height: '100%' }}>
              <NCROpenStatusGraph />
            </Card>
          </Grid2>


        </Grid2>
        <Box sx={{}}>
          <QualityNCRList />
        </Box>
      </CustomTabPanel>
    </>
  );
};

export default RiskDashBoard;